import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { MONTHS_ES, DAYS_ES } from "../constants";

export const CalendarPNL = ({ calendarData, currentMonth, setCurrentMonth }) => {
  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (year, month) => {
    const day = new Date(year, month, 1).getDay();
    return day === 0 ? 6 : day - 1;
  };

  const month = currentMonth.getMonth();
  const year = currentMonth.getFullYear();
  const daysInMonth = getDaysInMonth(year, month);
  const firstDay = getFirstDayOfMonth(year, month);

  const days = [];
  for (let i = 0; i < firstDay; i++) days.push({ key: `pad-${i}`, item: null });
  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    const dayData = calendarData?.find(cd => cd.date === dateStr);
    days.push({ key: dateStr, item: { day: d, pnl: dayData?.pnl, date: dateStr } });
  }

  const prevMonth = () => setCurrentMonth(new Date(year, month - 1, 1));
  const nextMonth = () => setCurrentMonth(new Date(year, month + 1, 1));

  return (
    <div data-testid="calendar-pnl" className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold text-white">PNL Diario</h3>
        <div className="flex items-center gap-4">
          <button onClick={prevMonth} data-testid="calendar-prev" className="p-1 hover:bg-gray-800 rounded transition-colors">
            <ChevronLeft className="w-5 h-5 text-gray-400" />
          </button>
          <span className="text-white font-medium min-w-[80px] text-center">{MONTHS_ES[month]} {year}</span>
          <button onClick={nextMonth} data-testid="calendar-next" className="p-1 hover:bg-gray-800 rounded transition-colors">
            <ChevronRight className="w-5 h-5 text-gray-400" />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1 mb-1">
        {DAYS_ES.map(day => (
          <div key={day} className="text-center text-gray-500 text-xs py-1">{day}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {days.map(({ key, item }) => (
          <div key={key} className={`h-14 flex flex-col items-center justify-center rounded-md border transition-all ${
            item === null ? 'border-transparent' 
              : item.pnl !== undefined
                ? item.pnl >= 0 ? 'border-emerald-500/30 bg-emerald-500/10 hover:bg-emerald-500/20' : 'border-red-500/30 bg-red-500/10 hover:bg-red-500/20'
                : 'border-gray-800 bg-gray-900/50'
          }`}>
            {item && (
              <>
                <span className="text-gray-300 text-xs">{item.day}</span>
                {item.pnl !== undefined && (
                  <span className={`text-[10px] font-medium ${item.pnl >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                    {item.pnl >= 0 ? '+' : ''}{item.pnl.toFixed(2)}
                  </span>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
